import classes from "./QuotationOverview.module.css";

import { useSelector } from "react-redux";

import { generateDatesBetween, numberWithCommas } from "../UI/Helper";

import BookingCurrencyConverter from "./BookingCurrencyConverter";

import ItemDescription from "../UI/ItemDescription";
import AirportTransfers from "./AirportTransfers";

import PriceItemOutput from "../UI/PriceItemOutput";
import { useEffect } from "react";

import { quoteActions } from "../../store/quote-slice";

import { bookingActions } from "../../store/booking-slice";

import { useDispatch } from "react-redux";

import Button from "../UI/Button";

import { popupActions } from "../../store/popup-slice";

import React, { useState } from 'react';

import ProgramDropDown from "./ProgramDropDown";

import AmityUSPHighlight from "./AmityUSPHighlight";

import CopyQuoteLinkButton from "./CopyQuoteLinkButton";

import { parse, format } from "date-fns";

//import SpecialPromotion from "../Redundant/SpecialPromotion";

// import AccommodationPref from './AccommodationPref'

const QuotationOverview = () => {
  const dispatch = useDispatch();

  const checkInDate = 
    useSelector((state) => state.booking.checkInDate)
  ;
  const checkOutDate = 
    useSelector((state) => state.booking.checkOutDate)
  ;


  
  const datesBetween = generateDatesBetween(checkInDate, checkOutDate);
  // console.log("Check-in Date:", checkInDate);
  // console.log("Check-out Date:", checkOutDate);
  // console.log(datesBetween);

   //Accommodaiton nights will be date of arrival to one date before check out date
  const accommodationDates = datesBetween.slice(0, -1);
  //Program starts one day after arrival and last full day of program is one day before leaving, last day is just colonic and breakfast
  const programDates = datesBetween.slice(1, -1);

   const forexCurrencyTicker = useSelector(
    (state) => state.quote.forexCurrencyTicker
  );

  const forexCurrencyRate = useSelector(
    (state) => state.quote.forexCurrencyRate
  );

  const extraBed = useSelector((state) => state.quote.extraBed);

  const forexSelected = forexCurrencyTicker !== "THB";

  const accommodationNights = accommodationDates.length;
  const programDays = programDates.length;

  let accommodationPref = useSelector((state) => state.quote.accomPref);

  switch (accommodationPref) {
    case "ground":
      accommodationPref = "Ground Floor";
      break;
    case "first":
      accommodationPref = "First Floor";
      break;
    case "bamboo":
        accommodationPref = "Bamboo Haven";
        break;
    default:
      accommodationPref = "No Preference";
  }

  const accommodationPrefClickHandlerToggle = (event) => {
    dispatch(popupActions.setAccommodationPopupShow());
  };

  const ReturningPopupShowGuestOne = (event) => {
    dispatch(popupActions.setReturningPopupShowGuestOne());
  };

  const ReturningPopupShowGuestTwo = (event) => {
    dispatch(popupActions.setReturningPopupShowGuestTwo());
  };

  const guest1ReturningToggleHandler = (event) => {
    dispatch(bookingActions.setGuest1ReturningToggle());
  };

  const guest2ReturningToggleHandler = (event) => {
    dispatch(bookingActions.setGuest2ReturningToggle());
  };

  // const ProgramPopupShowHandler = (event) => {
  //   dispatch(popupActions.setProgramPopupShow());
  // };

  useEffect(() => {
    dispatch(
      bookingActions.setAccommNightsProgramDays({
        accommNights: accommodationNights,
        programDays: programDays,
      })
    );
  }, [accommodationNights, programDays, dispatch]);

  const totalGuests = useSelector((state) => state.booking.totalGuests);
  const totalRooms = useSelector((state) => state.booking.totalRooms);

  const guest1Returning = useSelector((state) => state.booking.guest1Returning);
  const guest2Returning = useSelector((state) => state.booking.guest2Returning);

  let guest1ReturningEmail = useSelector(
    (state) => state.booking.guest1ReturningEmail
  );

  let guest2ReturningEmail = useSelector(
    (state) => state.booking.guest2ReturningEmail
  );

  if (guest1ReturningEmail) {
    guest1ReturningEmail = `Welcome Back! (${guest1ReturningEmail})`;
  }

  if (guest2ReturningEmail) {
    guest2ReturningEmail = `Welcome Back! (${guest2ReturningEmail})`;
  }


  const specialRates = useSelector(
    (state) => state.rates.specialRates
  );
  const defaultRate = useSelector(
    (state) => state.rates.defaultRate
  );

  const getDiscountsForDate = (dateString) => {
    const specialRate = specialRates.find(rate => {
      return dateString === rate.date;
    });
    if (specialRate) {
      return { 
        newGuestDiscount: specialRate.newGuestDiscount,
        returningGuestDiscount: specialRate.returningGuestDiscount,
        promotionName: specialRate.name
      };
    } else {
      return { 
        newGuestDiscount: defaultRate.newGuestDiscount,
        returningGuestDiscount: defaultRate.returningGuestDiscount,
        promotionName: 'default'
      };
    }
  };

  // Parse your stored format (dd/MM/yyyy)
const formattedCheckIn = checkInDate
  ? format(parse(checkInDate, "dd/MM/yyyy", new Date()), "EEE do MMM yy")
  : "";

const formattedCheckOut = checkOutDate
  ? format(parse(checkOutDate, "dd/MM/yyyy", new Date()), "EEE do MMM yy")
  : "";



  const baseAccommodationRate = useSelector(
    (state) => state.rates.baseAccommodationRate
  );

  let currentPromotionName = "default"

  const multipleRooms = totalRooms === 2;

  let accommodationCost = 0
  let accommodationDiscount = 0
  let accommodationReturningDiscount = 0

  for (const date of accommodationDates) {
    let { newGuestDiscount, returningGuestDiscount, promotionName } = getDiscountsForDate(date);

    accommodationCost += baseAccommodationRate
    accommodationDiscount += baseAccommodationRate * newGuestDiscount

    if (guest1Returning || guest2Returning) {
      accommodationReturningDiscount += Math.round(baseAccommodationRate * ((returningGuestDiscount - newGuestDiscount)));
    }

    if (multipleRooms) {
      accommodationCost += baseAccommodationRate
      accommodationDiscount += baseAccommodationRate * newGuestDiscount
  
      if (guest1Returning && guest2Returning) {
        accommodationReturningDiscount += Math.round(baseAccommodationRate * ((returningGuestDiscount - newGuestDiscount)));
      }
    }

    if (currentPromotionName === "default") {
     
      if (currentPromotionName !== promotionName) {
        currentPromotionName = promotionName;
      }
    }
  }

  // TO CHECK ACCOMMODATION COST
  // console.log(`accommodationCost: ${accommodationCost}`);
  // console.log(`accommodationDiscount: ${accommodationDiscount}`);
  // console.log(`accommodationReturningDiscount: ${accommodationReturningDiscount}`);


  const multipleGuests = totalGuests === 2;
  let programCost = 0
  let programDiscount = 0
  let programReturningDiscount = 0  

  const baseProgramRate = useSelector(
    (state) => state.rates.baseProgramRate
  );

  let firstDiscounts = null;
let crossesPromotionPeriod = false;
let promotionDetails = []; // Track each date and its discount

for (const date of programDates) {
  const { newGuestDiscount, returningGuestDiscount, promotionName } = getDiscountsForDate(date);

  // Log each date with its promotion info
  promotionDetails.push({
    date,
    promotionName: promotionName || 'Unnamed Promotion'
  });

  if (!firstDiscounts) {
    firstDiscounts = { newGuestDiscount, returningGuestDiscount };
  } else if (
    newGuestDiscount !== firstDiscounts.newGuestDiscount ||
    returningGuestDiscount !== firstDiscounts.returningGuestDiscount
  ) {
    crossesPromotionPeriod = true;
  }

  programCost += baseProgramRate;
  programDiscount += baseProgramRate * newGuestDiscount;

  if (guest1Returning) {
    programReturningDiscount += Math.round(baseProgramRate * (returningGuestDiscount - newGuestDiscount));
  }

  if (multipleGuests) {
    programCost += baseProgramRate;
    programDiscount += baseProgramRate * newGuestDiscount;

    if (guest2Returning) {
      programReturningDiscount += Math.round(baseProgramRate * (returningGuestDiscount - newGuestDiscount));
    }
  }
}

  // TO CHECK PROGRAM COST
  // console.log(`programCost: ${programCost}`);
  // console.log(`programDiscount: ${programDiscount}`);
  // console.log(`programReturningDiscount: ${programReturningDiscount}`);


  //const discountLabel = currentPromotionName === "default" ? "Special Discount" : "Limited Time Promo";

  let discountLabel;

  const uniquePromotions = [...new Set(promotionDetails.map(p => p.promotionName))];
  
  if (uniquePromotions.length === 1) {
    discountLabel = uniquePromotions[0];
  } else {
    discountLabel = "Mixed Promotion";
  }



  

  const totalCost = accommodationCost + programCost
  const discount = accommodationDiscount + programDiscount
  const returningDiscount = accommodationReturningDiscount + programReturningDiscount




  const finalCost = totalCost - discount - returningDiscount;

  const airportPickUp = useSelector((state) => state.quote.airportPickUp);
  const airportDropOff = useSelector((state) => state.quote.airportDropOff);

  let transferCost = 0;

  if (airportPickUp) {
    transferCost = transferCost + 1000;
  }

  if (airportDropOff) {
    transferCost = transferCost + 1000;
  }

  let totalQuotation = finalCost + transferCost;

  useEffect(() => {
    dispatch(
      quoteActions.setQuotationPrices({
        wellnessPackageCost: totalCost,
        totalDiscount: discount,
        returningDiscount: returningDiscount,
        transferCost: transferCost,
        grandTotal: totalQuotation,
        promotionName: discountLabel,
      })
    );
  }, [
    totalCost,
    discount,
    transferCost,
    returningDiscount,
    totalQuotation,
    discountLabel,
    dispatch,
  ]);

  const forexTotalCost = totalCost * forexCurrencyRate;
  const forexDiscount = discount * forexCurrencyRate;
  const forexReturningDiscount = returningDiscount * forexCurrencyRate;
  const forexFinalCost = finalCost * forexCurrencyRate;
  const forexTransferCost = transferCost * forexCurrencyRate;
  const forexTotalQuotation = forexFinalCost + forexTransferCost;

  const proceedButtonClickHandler = () => {
    dispatch(quoteActions.setQuoteAcceptedToggle());
  };

  const [showPromotionDetails, setShowPromotionDetails] = useState(false);




  return (
    <div className={classes.formContainer}>
      <div className={classes.summaryContainer}>
        {/* <AccommodationPref/> */}

        <AmityUSPHighlight/>

      <ItemDescription
        itemNumber={`${accommodationNights} Nights`}
        itemHeader="Accommodation Room One"
        itemSubheader={
          <>
            Check-in: {formattedCheckIn}
            <br />
            Check-out: {formattedCheckOut}
          </>
        }
        itemDescription={
          accommodationPref +
          (accommodationPref !== "No Preference"
            ? ` Preference (We will do our best to adhere to your request)`
            : ``)
        }
        itemSpecial={
          (accommodationPref === "No Preference"
            ? ""
            : accommodationPref) + (extraBed ? ` - Extra Bed` : ``)
        }
        itemToggle={accommodationPrefClickHandlerToggle}
        itemToggleText="Change Accommodation Preference"
      />

        <ItemDescription
          itemNumber={`${programDays} Days`}
          itemHeader="Wellness Program Guest One"
          itemSubheader={guest1ReturningEmail}
          itemSpecial={guest1Returning ? "Returning Guest" : "First Time Guest"}
          itemToggle={
            guest1Returning
              ? guest1ReturningToggleHandler
              : ReturningPopupShowGuestOne
          }
          itemToggleText={
            guest1Returning
              ? "Change - I am a first time guest"
              : "Please Click Here If You Are a Returning Guest"
          }
        />

        {multipleRooms && (
          <ItemDescription
            itemNumber={`${accommodationNights} Nights`}
            itemHeader="Accommodation Room Two"
            itemSubheader={
              <>
                Check-in: {formattedCheckIn}
                <br />
                Check-out: {formattedCheckOut}
              </>
            }
            itemDescription={
              accommodationPref +
              (accommodationPref !== "No Preference"
                ? ` Preference (We will do our best to adhere to your request)`
                : ``)
            }
            itemSpecial={
              (accommodationPref === "No Preference"
                ? ""
                : accommodationPref) + (extraBed ? ` - Extra Bed` : ``)
            }
            itemToggle={accommodationPrefClickHandlerToggle}
            itemToggleText="Change Accommodation Preference"
          />
        )}
        {multipleGuests && (
          <ItemDescription
            itemNumber={`${programDays} Days`}
            itemHeader="Wellness Program Guest Two"
            itemSubheader={guest2ReturningEmail}
            itemSpecial={
              guest2Returning ? "Returning Guest" : "First Time Guest"
            }
            itemToggle={
              guest2Returning
                ? guest2ReturningToggleHandler
                : ReturningPopupShowGuestTwo
            }
            itemToggleText={
              guest2Returning
                ? "Change - I am a first time guest"
                : "Please Click Here If You Are a Returning Guest"
            }
          />
        )}



        <AirportTransfers />
        <ProgramDropDown/>


     


        <div className={classes.QuoteBreakdownContainer}>
          <PriceItemOutput
            label="Wellness Package:"
            thbValue={numberWithCommas(totalCost)}
            forexValue={numberWithCommas(forexTotalCost)}
            forexSymbol={forexCurrencyTicker}
            forexSelected={forexSelected}
          />

          <PriceItemOutput
            label={`${discountLabel}:`}
            thbValue={`-${numberWithCommas(discount)}`}
            forexValue={`-${numberWithCommas(forexDiscount)}`}
            forexSymbol={forexCurrencyTicker}
            forexSelected={forexSelected}
          />
          {crossesPromotionPeriod && (
            <div>
              <div className={classes.promotionHeader}>
              <p className={classes.discountNote}>
            <span style={{
              color: 'white',
              backgroundColor: 'red',
              borderRadius: '50%',
              padding: '0 6px',
              display: 'inline-block',
              fontWeight: 'bold',
              fontSize: '12px',
              marginRight: '6px'
            }}>
              i
            </span>
            Spans two promotion periods.
          </p>
                <button
                  onClick={() => setShowPromotionDetails(!showPromotionDetails)}
                  className={classes.toggleButton}
                >
                  {showPromotionDetails ? 'Hide Details' : 'Show Details'}
                </button>
              </div>

              {showPromotionDetails && (
                <ul className={classes.promotionDetails}>
                  {promotionDetails.map((entry, index) => (
                    <li key={index} className={classes.promotionItem}>
                      {entry.date}: {entry.promotionName}
                    </li>
                  ))}
                </ul>
              )}
            </div>
          )}




          {returningDiscount > 0 && (
            <PriceItemOutput
              label="Returning Discount:"
              thbValue={`-${numberWithCommas(returningDiscount)}`}
              forexValue={`-${numberWithCommas(forexReturningDiscount)}`}
              forexSymbol={forexCurrencyTicker}
              forexSelected={forexSelected}
            />
          )}
          {transferCost > 0 && (
            <PriceItemOutput
              label="Airport Transfer:"
              thbValue={numberWithCommas(transferCost)}
              forexValue={numberWithCommas(forexTransferCost)}
              forexSymbol={forexCurrencyTicker}
              forexSelected={forexSelected}
            />
          )}

          <PriceItemOutput
            label="Total Quotation:"
            thbValue={numberWithCommas(totalQuotation)}
            forexValue={numberWithCommas(forexTotalQuotation)}
            forexSymbol={forexCurrencyTicker}
            forexSelected={forexSelected}
          />
          <p className={classes.tax}>(Taxes and Fees Included)</p>
        </div>
      </div>

   <div className={classes.datesSummary}>
          <p>
            <strong>Check-in:</strong> {formattedCheckIn}<br />
            <strong>Check-out:</strong> {formattedCheckOut}
          </p>

          <p>
            <strong>Accommodation:</strong> {accommodationNights} Nights
          </p>
          <p>
            <strong>Wellness Program:</strong> {programDays} Days
          </p>
          <p>
            <strong>Rooms:</strong> {totalRooms} {totalRooms === 1 ? "Room" : "Rooms"}{" "}
            {accommodationPref !== "No Preference" || extraBed ? (
              <span className={classes.muted}>
                ({accommodationPref !== "No Preference" ? accommodationPref : ""}
                {accommodationPref !== "No Preference" && extraBed ? " • " : ""}
                {extraBed ? "Extra Bed" : ""})
              </span>
            ) : null}
          </p>



          <p>
            <strong>Guests:</strong> {totalGuests} {totalGuests === 1 ? "Guest" : "Guests"}{" "}
            {totalGuests === 1 ? (
              guest1Returning ? (
                <span className={classes.muted}>(Returning)</span>
              ) : null
            ) : (
              (guest1Returning || guest2Returning) && (
                <span className={classes.muted}>
                  (
                  {guest1Returning ? "Guest 1: Returning" : ""}
                  {guest1Returning && guest2Returning ? " • " : ""}
                  {guest2Returning ? "Guest 2: Returning" : ""}
                  )
                </span>
              )
            )}
          </p>


        </div>


      <div className={classes.searchButtonContainer}>
        <Button onClick={proceedButtonClickHandler} buttonText="Proceed" />
      </div>

      <div className={classes.QuoteBreakdownContainer}></div>
      <p className={classes.forexAlert}>
        Exchange rates are approximate, Payments will be made in THB
      </p>
      <BookingCurrencyConverter />
      <CopyQuoteLinkButton />

    </div>
  );
};

export default QuotationOverview;
